module.exports = __webpack_public_path__ + "img/nt50-02a-80-1.prt.45749ca7.jpg";